import hungarian from "./hungarian";
import romanian from "./romanian";

const languages = {
  hu: hungarian,
  ro: romanian,
};

export const getLanguage = (langCode = 'hu') => {
  return languages[langCode] || languages.hu;
};

export const getSupportedLanguages = () => {
  return [
    { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
    { code: 'ro', name: 'Română', flag: '🇷🇴' }
  ];
};

export default getLanguage;
